import React from "react"
import { Button, Image } from "@chakra-ui/react"
import { useTranslation } from "react-i18next"
import { handleTrackAirlineButton } from "../services/analytics"
import QFLogo from "../img/QF.svg"
import VALogo from "../img/VA.svg"
import AALogo from "../img/AA.svg"

const bookingDetails = {
  QF: {
    logo: QFLogo,
    program: "qantas",
    airline: "Qantas Airlines",
  },
  VA: {
    logo: VALogo,
    program: "velocity",
    airline: "Velocity Airlines",
  },
  AA: {
    logo: AALogo,
    program: "american",
    airline: "American Airlines",
  },
}

const BookingButton = ({ url, children, source, to, ...className }) => {
  const { t } = useTranslation()

  const handleLinkClick = (airline) => {
    handleTrackAirlineButton({ name: airline })
  }

  const { logo, program, airline } = bookingDetails[source]
  const alt = t(`australianFlights.howToBookImageAlt`, { program, to })

  return (
    <Button
      as="a"
      href={url}
      onClick={() => handleLinkClick(airline)}
      target="_blank"
      backgroundColor={"transparent"}
      width={"fit-content"}
      height={"fit-content"}
      minWidth={"unset"}
      boxShadow="0px 2px 5px rgba(0, 0, 0, 0.1)"
      border={"1px solid #E8EBED"}
      borderRadius={"50%"}
      {...className}
      sx={{
        padding: 0,
        _hover: { backgroundColor: "transparent" },
      }}
    >
      {children ? (
        children
      ) : (
        <Image src={logo} width={"30px"} height={"30px"} alt={alt} />
      )}
    </Button>
  )
}

export default BookingButton
